export const practiceCategories = [
  { slug: "manifestation-coaches", shortName: "Manifestation" },
  { slug: "tarot-readers", shortName: "Tarot & oracle" },
  { slug: "psychics-intuitives", shortName: "Psychic & intuitive" },
  { slug: "mediums-mediumship", shortName: "Mediumship" },
  { slug: "astrologers", shortName: "Astrology" },
  { slug: "energy-practitioners", shortName: "Energy practice" },
  { slug: "spiritual-teachers-coaches", shortName: "Spiritual teaching" },
] as const;

const categoryTags: Record<string, string[]> = {
  "manifestation-coaches": [
    "manifestation",
    "manifesting",
    "manifestation coach",
    "manifestation teacher",
    "law of attraction",
    "law of attraction coach",
    "law of attraction teacher",
    "law of assumption",
    "law of assumption coach",
    "law of assumption teacher",
    "self concept",
    "self-concept",
    "reality shifting",
    "subliminals",
  ],
  "tarot-readers": ["tarot", "oracle", "oracle reading", "divination"],
  "psychics-intuitives": [
    "psychic",
    "intuitive",
    "clairvoyant",
    "clairvoyance",
    "channeling",
    "channelling",
  ],
  "mediums-mediumship": [
    "medium",
    "mediumship",
    "evidential mediumship",
    "spiritualist",
  ],
  astrologers: [
    "astrology",
    "astrologer",
    "natal astrology",
    "evolutionary astrology",
  ],
  "energy-practitioners": [
    "energy practice",
    "energy work",
    "energy healing",
    "reiki",
  ],
  "spiritual-teachers-coaches": [
    "spiritual coaching",
    "spiritual coach",
    "spiritual teaching",
    "spiritual teacher",
    "meditation",
    "mysticism",
    "nonduality",
    "transformational coaching",
  ],
};

export const categoryForTag = (tag: string) => {
  const normalised = tag.trim().toLowerCase();
  return practiceCategories.find((category) =>
    categoryTags[category.slug].includes(normalised),
  );
};
